export default __webpack_public_path__ + "static/media/image-1.4a9888da.png";